import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EditableStudyMaterialTypeEnum } from '@edtech-ui/constants/editable-material-type.enum';
@Component({
	selector: 'app-edit-course-title',
	standalone: true,
	imports: [ReactiveFormsModule,CommonModule],
	templateUrl: './edit-course-title.component.html',
	styleUrl: './edit-course-title.component.scss'
})
export class EditCourseTitleComponent {

	editForm!: FormGroup;
	_EditableStudyMaterialTypeEnum = EditableStudyMaterialTypeEnum

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { editTitle: string, label: EditableStudyMaterialTypeEnum, timeLimit?: number, showTimer?: boolean },
		@Optional() private dialogRef: MatDialogRef<EditCourseTitleComponent>
	) {

		let hours = 0, minutes = 0, seconds = 0;
		if (this.data.label === 'Quiz' && this.data.timeLimit) {
			hours = Math.floor(this.data.timeLimit / 3600);
			minutes = Math.floor((this.data.timeLimit % 3600) / 60);
			seconds = this.data.timeLimit % 60;
		}

		this.editForm = new FormGroup({
			editTitle: new FormControl(this.data.editTitle, Validators.required),
			hours: new FormControl(hours, [Validators.min(0)]),
			minutes: new FormControl(minutes, [Validators.min(0), Validators.max(99), Validators.maxLength(2)]),
			seconds: new FormControl(seconds, [Validators.min(0), Validators.max(99), Validators.maxLength(2)]),
		})
	}

	onClose(){
		this.dialogRef.close();
	}

	onEditTitle() {
		if(this.editForm.valid) {

			if (this.data.label === EditableStudyMaterialTypeEnum.Quiz) {
				const { editTitle, hours, minutes, seconds } = this.editForm.value;
				const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
				this.dialogRef.close({ quiz_name: editTitle, time_limit: totalSeconds });
			} else {
				this.dialogRef.close(this.editForm.value.editTitle);
			}
		}
	}

}